import { request } from '../lib/http'

export function fetchClients () {
  return request({
    url: 'financial/clients',
    method: 'get'
  })
}

// export function fetchFiltered(queriesParams) {
//   return request({
//     url: `banks`,
//     method: 'get',
//     params: queriesParams
//   })
// }

export function addVehicle (vehicle) {
  return request({
    method: 'post',
    url: 'financial/vehicle',
    data: vehicle
  })
}

export function fetchVehicleById (id) {
  return request({
    url: `financial/vehicle/${id}`,
    method: 'get'
  })
}

export function editVehicle (id, data) {
  return request({
    url: `financial/vehicle/${id}`,
    method: 'patch',
    data
  })
}

export function activeVehicle (id) {
  return request({
    url: `financial/vehicle/active/${id}`,
    method: 'patch'
  })
}

export function inactiveVehicle (id, data) {
  return request({
    url: `financial/vehicle/inactive/${id}`,
    method: 'patch',
    data
  })
}
